module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.is_manager) ? _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "6%",
      "margin-left": "33%",
      "float": "center"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "文档标题"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "父目录"
    }
  }, [_c('el-cascader', {
    attrs: {
      "change-on-select": "",
      "options": _vm.form.options,
      "clearable": ""
    },
    model: {
      value: (_vm.selectedItemList),
      callback: function($$v) {
        _vm.selectedItemList = $$v
      },
      expression: "selectedItemList"
    }
  }), _vm._v("\n                若需创建在根目录下则无需选择\n            ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "文档类型"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "目录"
    }
  }), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "文本"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "语言"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.language),
      callback: function($$v) {
        _vm.$set(_vm.form, "language", $$v)
      },
      expression: "form.language"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "zh"
    }
  }, [_vm._v("中文")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "en"
    }
  }, [_vm._v("英文")])], 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("立即创建")])], 1)], 1)], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7df4dd3f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/addItem.vue
// module id = 654
// module chunks = 1